import { ChangeDetectionStrategy, Component, EventEmitter, Output, input } from '@angular/core';
import { TableColumn } from '../../models/table-column.model';

@Component({
  selector: 'cosmos-data-table',
  templateUrl: './data-table.component.html',
  styleUrls: ['./data-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class DataTableComponent {
  readonly columns = input<TableColumn[]>(undefined);
  readonly sortedBy = input<string>(undefined);

  @Output() sortBy = new EventEmitter<{ key: string; direction: string }>();

  public sort(key: string, direction: string): void {
    this.sortBy.emit({ key, direction });
  }
}
